const BASE = process.env.VUE_APP_API_BASE || ''

class APIError extends Error {
	constructor({ error, statusCode, message }) {
		super(message || `${statusCode} ${error}`)
		this.name = 'APIError'
		this.error = error
		this.status = statusCode
	}
}

class APIValidationError extends APIError {
	constructor({ error, statusCode, message }) {
		super({ error, statusCode })
		this.name = 'APIValidationError'
		this.errors = message
	}
}

async function throwAPIError(res) {
	let body
	try {
		body = await res.json()
	} catch (error) {
		// Handle JSON parse errors
		const { status, statusText } = res
		body = { error, statusCode: status, message: statusText }
	}

	// Pass through server errors
	switch (typeof body.message) {
		case 'object':
			throw new APIValidationError(body)
		default:
			throw new APIError(body)
	}
}

// Inject base options
function injectDefaults(opts) {
	// Set default HTTP method
	if (!opts.method) opts.method = 'GET'
	if (!opts.headers) opts.headers = {}

	// If body is a string, set application/json content type
	if (opts.body && typeof opts.body === 'string') {
		opts.headers['Content-Type'] = 'application/json'
	}
}

export const apiUrl = endpoint => BASE + endpoint

export default function request(options = {}) {
	// Inject auth and headers
	injectDefaults(options)
	// Make request
	const url = BASE + options.endpoint
	return window.fetch(url, options).then(async res => {
		if (res.ok) return { req: options, res }
		else return throwAPIError(res)
	})
}
